import React from 'react'
import PropType from 'prop-types'
import Lib from '../../loader'

function Actions({ children }) {
  return (
    <Lib.CardActions>
      { children }
    </Lib.CardActions>
  )
}

Actions.defaultProps = {
  children: null,
}

Actions.propTypes = {
  children: PropType.node,
}

export default Actions
